import React from 'react'
import ResiembraVicia from '../../components/ResiembraVicia/ResiembraVicia'

const ResiembraViciaPage = () => {
  return <ResiembraVicia />
}

export default ResiembraViciaPage
